import Grid from '@mui/material/Grid';
import "./style.css";
import React from 'react';
import {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { purple } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import axios from 'axios';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography'
import SendIcon from '@mui/icons-material/Send';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, LinearProgress, DialogContent} from '@mui/material';

export default function UpdateConfirmPopUp({closeupdateKontrakconfirmopen, changeKlienPopUpClose, setContractData, contractData}){
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const yakinUpdate = () => {
        setLoading(true);
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/updateKontrak`, {
          contractData
        }).then(() => {
          return axios.post(`${process.env.REACT_APP_BACKEND_URL}/companytoKlien`, { contractData });
        })
        .then(() => {
          return axios.post(`${process.env.REACT_APP_BACKEND_URL}/renderKontrakVOfromDB`, { id: contractData._id }, { responseType: "blob" });
        })
        .then(resp => {
          const blob = new Blob([resp.data], { type: 'application/pdf' })
          var fileURLNew = URL.createObjectURL(blob);
          console.log(fileURLNew)
          window.open(fileURLNew, '_blank');
          setLoading(false);
          navigate("/Kontrak")
        })
        .catch(error => {
          console.log("Request failed", error);
        });
      }
      
      
return(<Grid sx={{p:2}}>
            <Dialog open={loading} aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "100px",  // Set your width here
                        },
                    },}}>
                    <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                    </DialogContent>
                </Dialog>
    <Grid><b>Apakah benar kamu mau melakukan perubahaan ini?</b></Grid>
    <Grid>Setelah melakukan perubahan, <p style={{color: "red"}}>kamu tidak bisa mengubahnya seperti semula!</p></Grid>
    <Button variant="contained" endIcon={<SendIcon />} sx={{mr:5}} onClick={yakinUpdate}>Saya Yakin</Button>
    <Button variant="contained" startIcon={<DeleteIcon />} color="error" onClick={closeupdateKontrakconfirmopen}>Cancel</Button>
</Grid>)
};